import DescriptionField from '../DescriptionField/DescriptionField';
import TitleField from '../TitleField/TitleField';

export default {
  DescriptionField,
  TitleField,
};
